var resolve = require("./resolve");
var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");

exports.GetMatchedSchemes = function (funderId, filter, amountFilter, amountExpression, percentFilter, percentExpression, ordering, deviation, schemeId, pageSize, pageNumber, viewname) {
  var qry = {
    filter: filter,
    amount: amountFilter,
    amountExpression: amountExpression,
    percent: percentFilter,
    percentExpression: percentExpression,
    ordering: ordering,
    deviation: deviation,
    schemeId: schemeId,
    viewName: viewname,
    take: pageSize,
    pageNumber: pageNumber
  };
  return request.get(resolve(config.url(), 'applications/funder/' + funderId + '/schemesmatch'), qry).promise();
};
exports.CreateFunder = function(funder) {
  return request.post(resolve(config.url(), "/funders"), funder).promise();
};
exports.UpdateFunder = function(id, funder) {
  return request.put(resolve(config.url(), "/funders/" + id), funder).promise();
};
exports.GetCurrentFunder = function(viewName) {
  var qry = {
    viewName: viewName
  };
  return request.get(resolve(config.url(), "funders/current"), qry).promise();
};

exports.GetFunder = function(funderId, viewName) {
  var qry = {
    viewName: viewName
  };
  return request.get(resolve(config.url(), "funders/" + funderId), qry).promise();
};

exports.GetByFunderRef = function(funderRef, viewName) {
  var qry = {
    viewName: viewName
  };
  return request.get(resolve(config.url(), "funders/byFunderRef/" + funderRef), qry).promise();
};

exports.GetAdminFunders = function(filter, viewName) {
  var qry = {
    filter: filter,
    viewName: viewName
  };
  return request.get(resolve(config.url(), "funders"), qry).promise();
};
exports.searchFunders = function(filter, viewName, pageSize, pageNumber) {
  var qry = {
    filter: filter,
    viewName: viewName,
    pageSize: pageSize,
    pageNumber: pageNumber
  };
  return request.get(resolve(config.url(), "funders/search"), qry).promise();
};
exports.UpdateFunderOrganisationName = function(funderId, name) {
  var rqst = {
    funderId: funderId,
    name: name
  };

  return request.put(resolve(config.url(), "/funders/update/name"), rqst).promise();
};
exports.UpdateFunderOrganisationFunderName = function(funderId, funderName) {
  var rqst = {
    funderId: funderId,
    funderName: name
  };

  return request.put(resolve(config.url(), "/funders/update/name"), rqst).promise();
};




exports.UpdateFunderOrganisationFunderDescription = function(funderId, funderDescription) {
  var rqst = {
    funderId: funderId,
    funderDescription: description
  };

  return request.put(resolve(config.url(), "/funders/update/description"), rqst).promise();
};




exports.UpdateFunderOrganisationTelephoneNumber = function(funderId, telephoneNumber) {
  var rqst = {
    funderId: funderId,
    telephoneNumber: telephoneNumber
  };

  return request.put(resolve(config.url(), "/funders/update/telephoneNumber"), rqst).promise();
};




exports.UpdateFunderOrganisationWebsiteUrl = function(funderId, websiteUrl) {
  var rqst = {
    funderId: funderId,
    websiteUrl: websiteUrl
  };

  return request.put(resolve(config.url(), "/funders/update/websiteUrl"), rqst).promise();
};
exports.UpdateFunderOrganisationLegalStatus = function(funderId, legalStatusId) {
  var rqst = {
    funderId: funderId,
    legalStatusId: legalStatusId
  };

  return request.put(resolve(config.url(), "/funders/update/legalStatus"), rqst).promise();
};
exports.UpdateFunderOrganisationType = function(funderId, organisationTypeId) {
  var rqst = {
    funderId: funderId,
    organisationTypeId: organisationTypeId
  };

  return request.put(resolve(config.url(), "/funders/update/organisationType"), rqst).promise();
};
exports.UpdateFunderOrganisationAddress = function(funderId, addressLine1, addressLine2, addressLine3, townOrCity, countyOrState, postcodeOrZip) {
  var rqst = {
    funderId: funderId,
    addressLine1: addressLine1,
    addressLine2: addressLine2,
    addressLine3: addressLine3,
    townOrCity: townOrCity,
    countyOrState: countyOrState,
    postcodeOrZip: postcodeOrZip
  };
  return request.put(resolve(config.url(), "/funders/update/address"), rqst).promise();
};

exports.UpdatePublicDescription = function(funderId, description) {
  var rqst = {
    publicDescription: description
  };
  return request.put(resolve(config.url(), "/funders/" + funderId + "/publicdescription"), rqst).promise();
};

exports.UpdateDescription = function (funderId, description) {
    var rqst = {
        funderId: funderId,
        description: description
    };
    return request.put(resolve(config.url(), "/funders/update/description"), rqst).promise();
};
exports.UpdateFunderAnnualRevenue = function(funderId, annualRevenue) {
  var rqst = {
    funderId: funderId,
    annualRevenue: annualRevenue
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/annualRevenue"), rqst).promise();
};
exports.UpdateYearFunding = function(funderId, year, fundingAmount) {
  var rqst = {
    funderId: funderId,
    year: year,
    fundingAmount: fundingAmount
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/yearFunding"), rqst).promise();
};
exports.UpdateIsAnnualRevenuePublic = function(funderId, ispublic) {
  var rqst = {
    funderId: funderId,
    isPublic: ispublic
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/isAnnualRevenuePublic"), rqst).promise();
};
exports.UpdateIsPreviousFundingPublic = function(funderId, ispublic) {
  var rqst = {
    funderId: funderId,
    isPublic: ispublic
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/isPreviousFundingPublic"), rqst).promise();
};
exports.CreateMatchingCriteria = function(matchingCriteria, funderId) {
  return request.post(resolve(config.url(), "/funders/" + funderId + "/matchingcriteria"), matchingCriteria).promise();
};
exports.UpdateMatchingCriteria = function(matchingCriteria, funderId) {
  return request.put(resolve(config.url(), "/funders/" + funderId + "/matchingcriteria"), matchingCriteria).promise();
};
exports.GetSingleMatchingCriteria = function(questionId, funderId) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/matchingcriteria?questionId=" + questionId)).promise();
};
exports.GetAllMatchingCriteriaQuestionIds = function(funderId) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/matchingcriteria/QuestionId/all")).promise();
};
exports.DeleteMatchingCriteria = function(funderId, criteriaId) {
  return request.del(resolve(config.url(), "/funders/" + funderId + "/match?criteriaId=" + criteriaId)).promise();
};
exports.GetAdditionalQuestions = function(funderId) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/additionalquestions")).promise();
};
exports.UpdateAdditionalQuestions = function(funderId, data) {
  return request.post(resolve(config.url(), "/funders/" + funderId + "/additionalquestions"), data).promise();
};
exports.ChangeApplicationStatus = function(funderId, funderApplicationId, statusId, schemeId, grantRoundId) {
  var url = resolve(config.url(), "/funders/" + funderId + "/applications/" + funderApplicationId) + "/funderapplicationstatus";
  return request.post(url, {
    funderApplicationStatusId: statusId,
    schemeId: schemeId,
    grantRoundId: grantRoundId
  }).promise();
};
exports.GetFunderShortList = function(funderId, viewName, filter, applicationStatusId, provisionalSchemeId, provisionalGrantRoundId, showOnlyUnassignedGrantRoundSchemes, sort, pageNumber, pageSize) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/shortlist?viewName=" + viewName + "&filter=" + filter + "&applicationStatusId=" + applicationStatusId +
  "&provisionalSchemeId=" + provisionalSchemeId + "&provisionalGrantRoundId=" + provisionalGrantRoundId + "&showOnlyUnassignedGrantRoundSchemes=" + showOnlyUnassignedGrantRoundSchemes
  + "&sort=" + sort + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize)).promise();
};
exports.GetFunderShortListSelected = function (funderId, applicationIds, viewName, filter, applicationStatusId, provisionalSchemeId, provisionalGrantRoundId, showOnlyUnassignedGrantRoundSchemes, sort, pageNumber, pageSize) {
	var req = {
		funderId: funderId,
		applicationIds: applicationIds,
		viewName: viewName,
		filter: filter,
		applicationStatusId: applicationStatusId,
		provisionalSchemeId: provisionalSchemeId,
		provisionalGrantRoundId: provisionalGrantRoundId,
		showOnlyUnassignedGrantRoundSchemes: showOnlyUnassignedGrantRoundSchemes,
		sort: sort,
		pageNumber: pageNumber,
		pageSize: pageSize
	};
	return request.post(resolve(config.url(), "/funders/" + funderId + "/shortlist/selected"), req).promise();
};
exports.AddApplicationToShortList = function(funderId, applicationId, schemeId, grantRoundId) {
  var req = {
    applicationId: applicationId,
    schemeId: schemeId,
    grantRoundId: grantRoundId
  };
  return request.post(resolve(config.url(), "/funders/" + funderId + "/shortlist"), req).promise();
};
exports.AddMultipleApplicationsToShortList = function(funderId, applicationIds, schemeId, grantRoundId) {
  var req = {
    applicationIds: applicationIds,
    schemeId: schemeId,
    grantRoundId: grantRoundId
  };
  return request.post(resolve(config.url(), "/funders/" + funderId + "/shortlist/multiple"), req).promise();
};
exports.RemoveApplicationFromShortList = function(funderId, funderApplicationId) {
  return request.del(resolve(config.url(), "/funders/" + funderId + "/shortlist/" + funderApplicationId)).promise();
};
exports.GetFunderApplications = function(funderId, applicationId) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/application/" + applicationId)).promise();
};
exports.UpdateFunderOrganisationOtherLegalStatus = function(funderId, otherLegalStatus) {
  var rqst = {
    otherLegalStatus: otherLegalStatus
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/otherlegalStatus"), rqst).promise();
};
exports.UpdateFunderOtherOrganisationType = function(funderId, otherOrganisationType) {
  var rqst = {
    otherOrganisationType: otherOrganisationType
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/otherOrganisationType"), rqst).promise();
};
exports.UpdateFunderOrganisationProfile = function(funderId, organisationProfile) {
  var rqst = {
    organisationProfile: organisationProfile
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/organisationProfile"), rqst).promise();
};
exports.UpdateFunderRegistrationNumber = function(funderId, registrationNumber) {
  var rqst = {
    registrationNumber: registrationNumber
  };

  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/registrationNumber"), rqst).promise();
};
exports.UpdateFunderOrganisationFinancialInformation = function(funderId, financialInformation) {
  return request.put(resolve(config.url(), "/funders/" + funderId + "/update/organisationFinancialInformation"), financialInformation).promise();
};
exports.GetMatchingCriteriaQuestions = function() {
  return request.get(resolve(config.url(), "funders/matchingCriteriaQuestions")).promise();
};
exports.CreateScheme = function(funderId, scheme) {
  return request.post(resolve(config.url(), "/funders/" + funderId + "/scheme"), scheme).promise();
};
exports.SaveScheme = function(funderId, schemeId, scheme) {
  return request.put(resolve(config.url(), "/funders/" + funderId + "/scheme/" + schemeId), scheme).promise();
};
exports.GetSchemes = function(funderId, includeInactive, includeActive, sortBy, viewName) {

  var qry = {
    includeInactive: includeInactive,
    includeActive: includeActive,
    sortBy: sortBy
  };
  if (viewName) {
    qry.viewName = viewName;
  };
  return request.get(resolve(config.url(), "/funders/" + funderId + "/schemes"), qry).promise();
};
exports.GetApplicationMatchingDetails = function(funderId, applicationId, schemeId){
  return request.get(resolve(config.url(), '/funders/' + funderId + '/applicationmatchingdetails?applicationId=' + applicationId + '&schemeId=' + schemeId)).promise();
};
exports.CreateApplicationFunding = function(funderId, rqst) {
  return request.post(resolve(config.url(), "/funders/" + funderId + "/funding"), rqst).promise();
};
exports.UpdateApplicationFunding = function(funderId, rqst) {
  return request.put(resolve(config.url(), "/funders/" + funderId + "/funding"), rqst).promise();
};
exports.GetApplicationFunding = function(funderId, applicationId, fundingId, viewName) {

  var qry = {
    applicationId: applicationId,
    viewName: viewName,
    fundingId: fundingId
  };
  return request.get(resolve(config.url(), "/funders/" + funderId + "/funding"),qry).promise();
};
exports.GetApplicationFundingHistory = function(funderId, applicationId, viewName, includeCancelled) {
  var qry = {
    applicationId: applicationId,
    viewName: viewName,
    includeCancelled: includeCancelled,
  }
  return request.get(resolve(config.url(), "/funders/" + funderId + "/fundingHistory"), qry).promise();
};
exports.SubmitApplicationFunding = function(fundingId, autoConfirm) {
  var rqst = {
    autoConfirm: autoConfirm
  }
  return request.patch(resolve(config.url(), "/funders/funding/" + fundingId + "/submitted"), rqst).promise();
};
exports.WithdrawFundingOffer = function(fundingId, reason) {
  var rqst = {
    reason: reason,
  }
  return request.post(resolve(config.url(), "/funders/funding/" + fundingId + "/withdraw"), rqst).promise();
}
exports.CancelFundingOffer = function(fundingId, reason) {
  var rqst = {
    reason: reason,
  }
  return request.post(resolve(config.url(), "/funders/funding/" + fundingId + "/cancel"), rqst).promise();
}
exports.ConfirmFundingOffer = function(fundingId) {
    return request.post(resolve(config.url(), "/funders/funding/" + fundingId + "/confirm")).promise();
}
exports.GetfunderApplicationStatuses = function(funderId, viewName, pageSize, pageNumber) {
  var qry = {
    viewName: viewName,
    pageSize: pageSize,
    pageNumber: pageNumber,
  };
  return request.get(resolve(config.url(), "/funders/" + funderId + "/applicationStatuses"), qry).promise();
};
exports.CreateFunderApplicationStatus = function(funderId, name, order) {
  var rqst = {
    name: name,
    order: order,
  };
  return request.post(resolve(config.url(), "/funders/" + funderId + "/applicationStatus"), rqst).promise();
};
exports.UpdateFunderApplicationStatus = function(funderApplicationStatusId, name, order) {
  var rqst = {
    name: name,
    order: order,
  };
  return request.put(resolve(config.url(), "/funders/applicationStatus/" + funderApplicationStatusId), rqst).promise();
};
exports.DeleteFunderApplicationStatus = function(funderApplicationStatusId) {
  return request.del(resolve(config.url(), "/funders/applicationStatus/" + funderApplicationStatusId)).promise();
};

exports.GetFunderUsers = function(funderId) {
  return request.get(resolve(config.url(), '/funders/' + funderId + '/users')).promise();
}

exports.RemoveFunderUser = function(funderId, userId) {
  return request.del(resolve(config.url(), '/funders/' + funderId + '/users/' + userId)).promise();
}

exports.ManageFunderUserClaims = function(funderId, userId, claim, hasClaim){
  //{id}/users/{userId}
  var qry = {
    claim: claim,
    hasClaim: hasClaim
  }
  return request.put(resolve(config.url(), '/funders/' + funderId + '/users/' + userId), qry).promise();
}

exports.InviteUserToJoinFunder = function(funderId, emailAddress){
  var inviteUrl = resolve(config.baseUrl(), '/funder-invite');
  var qry = {
    emailAddress: emailAddress,
    inviteUrl: inviteUrl
  }
  return request.post(resolve(config.url(), '/funders/' + funderId + '/inviteuser'), qry).promise();
}

exports.GetInvitationDetails = function(invitationId){
  return request.get(resolve(config.url(), '/funders/invite/' + invitationId)).promise();
}

exports.AddInvitedFunderUser = function(funderId, invitationId) {
  var qry = {
    inviteId: invitationId
  }
  return request.post(resolve(config.url(), '/funders/' + funderId + '/inviteduser'), qry).promise();
}

exports.AddApplicationHistoryNote = function(funderId, applicationId, note, name) {
  var rqst = {
    applicationId: applicationId,
    note: note,
    createdby: name
  };
  return request.post(resolve(config.url(), '/funders/' + funderId + '/applicationhistory'), rqst).promise();
}

exports.GetInvites = function(funderid){
  return request.get(resolve(config.url(), '/funders/' + funderid + '/invites')).promise();
}

exports.GetDirectApplications = function(funderId, filter, remainingFilter, remainingExpression, percentFilter, percentExpression, ordering, deviation, schemeId, pageSize, pageNumber, viewName) {
  var qry = {
    filter: filter,
    remaining: remainingFilter,
    remainingExpression: remainingExpression,
    percent: percentFilter,
    percentExpression: percentExpression,
    ordering: ordering,
    deviation: deviation,
    schemeId: schemeId,
    take: pageSize,
    pageNumber: pageNumber,
    viewName: viewName
  };
  return request.get(resolve(config.url(), '/funders/' + funderId + '/applications/direct'), qry).promise();
}

exports.AddGalleryItem = function (funderId, item) {
    return request.post(resolve(config.url(), "/funders/" + funderId + "/galleryitems"), item).promise();
};

exports.UpdateGalleryItem = function (funderId, itemId, item) {
    var url = resolve(config.url(), "/funders/" + funderId + "/galleryitems/" + itemId);
    return request.put(url, item).promise();
};

exports.DeleteGalleryItem = function (funderId, itemId) {
    var url = resolve(config.url(), "/funders/" + funderId + "/galleryitems/" + itemId);
    return request.del(url).promise();
};

exports.GetSupportedApplications = function (funderId) {
    var url = resolve(config.url(), "/funders/" + funderId + "/supportedApplications/");
    return request.get(url).promise();
};

exports.AddPaymentTerm = function(funderId, item){
  return request.post(resolve(config.url(), '/funders/' + funderId + '/application/paymentterm'), item).promise();
}

exports.DeletePaymentTerm = function(funderId, paymentTermId){
  return request.del(resolve(config.url(), '/funders/' + funderId + '/application/paymentterm/' + paymentTermId)).promise();
}

exports.GetFunderApplicationPaymentTerms = function(funderid, applicationId, fundingOfferId, pageNumber, pageSize) {
  var qry = {
    applicationId: applicationId,
    fundingOfferId: fundingOfferId,
    viewName: 'FunderApplicationPaymentTermView',
    pageNumber: pageNumber,
    pageSize: pageSize
  }
  return request.get(resolve(config.url(), '/funders/' + funderid + '/application/paymentterms'), qry).promise();
}

exports.GetPayments = function(funderId, grantRoundId, schemeId, paymentFilter, pageNumber, pageSize){
  var qry = {
    schemeId: schemeId,
    grantRoundId: grantRoundId,
    viewName: 'FunderPaymentView',
    paymentTypeFilter: paymentFilter,
    pageNumber: pageNumber,
    pageSize: pageSize
  }
  return request.get(resolve(config.url(), '/funders/' + funderId + '/payments'), qry).promise();
}

exports.UpdatePayment = function(funderId, id, paymentDate, expectedPaymentDate, filename){
  var payment = {
    filename: filename,
    paymentDate: paymentDate,
    expectedPaymentDate: expectedPaymentDate,
    paymentId: id
  }
  return request.put(resolve(config.url(), "/funders/" + funderId + "/payment"), payment).promise();
}

exports.CheckFunderIsVerified = function(funderId){
  return request.get(resolve(config.url(), "/funders/" + funderId + "/isverified")).promise();
}

exports.SetApplicationVisibleFlag = function(funderId, applicationId, isVisible) {
  var query = {
    applicationId: applicationId,
    isVisible: isVisible
  };
  return request.put(resolve(config.url(), "/funders/" + funderId + "/visible"), query).promise();
}

exports.CreateRecommendation = function(funderId, item){
  return request.post(resolve(config.url(), '/funders/' + funderId + '/application/fundingrecommendations'), item).promise();
}

exports.GetAdditionalQuestionSetsForApplication = function(funderId, applicationId) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/additionalquestionsets"), {
    applicationId : applicationId
  }).promise();
}

exports.GetMatchPreferences = function(funderId, schemeId){
  return request.get(resolve(config.url(), "/funders/" + funderId + "/matchPreferences/" + schemeId)).promise();
}

exports.SaveMatchPreferences = function(funderId, qry){
  return request.put(resolve(config.url(), "/funders/" + funderId + "/matchPreferences"), qry).promise();
}

exports.RemoveFunderInvitation = function(funderId, inviteId) {
  return request.del(resolve(config.url(), '/funders/' + funderId + '/invite/' + inviteId)).promise();
}
exports.GetFunderInFunding = function(funderId, viewName, filter, provisionalSchemeId, provisionalGrantRoundId, showOnlyUnassignedGrantRoundSchemes, offerStatusId, offerTypeId, projectFundingStatusId, sort, pageNumber, pageSize) {
  return request.get(resolve(config.url(), "/funders/" + funderId + "/infunding?viewName=" + viewName + "&filter=" + filter +
  "&provisionalSchemeId=" + provisionalSchemeId + "&provisionalGrantRoundId=" + provisionalGrantRoundId + "&showOnlyUnassignedGrantRoundSchemes=" + showOnlyUnassignedGrantRoundSchemes
  + "&offerStatusId=" + offerStatusId + "&offerTypeId=" + offerTypeId + "&projectFundingStatusId=" + projectFundingStatusId
  + "&sort=" + sort + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize)).promise();
};

exports.GetOtherFundingOffers = function(fundingOfferId, includePreviousMatches){
  var previous = false;
  if(includePreviousMatches){
    previous = includePreviousMatches;
  }
  return request.get(resolve(config.url(), "/funders/funding/" + fundingOfferId + "/otheroffers?includePreviouslyMatched=" + previous)).promise();
}

exports.MatchGrantFundingOffers = function(fundingOfferId, items, paymentDate){
  var req = {
    fundingOfferId: fundingOfferId,
    matchedGrantFundingItems: items,
    paymentDate: paymentDate
  };
  return request.post(resolve(config.url(), "/funders/funding/" + fundingOfferId + "/matchgrants"), req).promise();
}

exports.CheckCurrentFundingOfferRequirements = function (fundingOfferId) {
  return request.get(resolve(config.url(), '/funders/funding/' + fundingOfferId +'/remaining')).promise();
}
